var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChattingOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3523_168428)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3523_168428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.394531 1.90735e-06H32.3946V32H0.394531V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3523_168428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.582 18.8137C10.582 18.0543 9.96641 17.4387 9.20703 17.4387C8.44766 17.4387 7.83203 18.0543 7.83203 18.8137C7.83203 19.5731 8.44766 20.1887 9.20703 20.1887C9.96641 20.1887 10.582 19.5731 10.582 18.8137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.582 18.8137C15.582 18.0543 14.9664 17.4387 14.207 17.4387C13.4477 17.4387 12.832 18.0543 12.832 18.8137C12.832 19.5731 13.4477 20.1887 14.207 20.1887C14.9664 20.1887 15.582 19.5731 15.582 18.8137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5781 18.8137C20.5781 18.0543 19.9625 17.4387 19.2031 17.4387C18.4438 17.4387 17.8281 18.0543 17.8281 18.8137C17.8281 19.5731 18.4438 20.1887 19.2031 20.1887C19.9625 20.1887 20.5781 19.5731 20.5781 18.8137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3008 9.56372H5.76954C3.14622 9.56372 1.01953 11.6903 1.01953 14.3137V23.0637C1.01953 25.6871 3.14622 27.8137 5.76954 27.8137H14.7696V31.3137L18.2696 27.8137H22.6446C25.2679 27.8137 27.3946 25.6871 27.3946 23.0637V17.4075",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2695 2.91559V8.05684C15.2695 13.2512 18.6309 17.8551 23.5195 19.4702C28.4082 17.8551 31.7696 13.2512 31.7696 8.05684V2.91559C28.9055 2.64684 26.1043 1.89103 23.5195 0.686277C20.9348 1.89103 18.1336 2.64684 15.2695 2.91559Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5932 7.68018V6.98824C25.5932 5.84174 24.6638 4.9123 23.5173 4.9123C22.3708 4.9123 21.4414 5.84174 21.4414 6.98824V7.68018",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.215 11.2434V12.4847H22.84V11.2434C22.6479 11.0612 22.5275 10.8042 22.5275 10.5185C22.5275 9.96619 22.9752 9.5185 23.5275 9.5185C24.0797 9.5185 24.5275 9.96619 24.5275 10.5185C24.5275 10.8042 24.407 11.0612 24.215 11.2434ZM26.2874 7.68019H20.7517C20.1402 7.68019 19.6445 8.17587 19.6445 8.78731V13.2159C19.6445 13.8274 20.1402 14.323 20.7517 14.323H26.2874C26.8989 14.323 27.3945 13.8274 27.3945 13.2159V8.78731C27.3945 8.17587 26.8989 7.68019 26.2874 7.68019Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3523_168428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0001,
    height: 32,
    fill: "white",
    transform: "translate(0.386719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChattingOutlinedWhite);
export default __webpack_public_path__ + "static/media/icon_chatting_outlined_white.504ca145993a064f507d3cf02480090d.svg";
export { ForwardRef as ReactComponent };